import { ButtonTab, ButtonTabs } from "@dgs/core";
import { useTranslation } from "react-i18next";

export const EventListCalendarSwitcher = () => {
	const { t } = useTranslation();

	return (
		<ButtonTabs>
			<ButtonTab to={`../calendar`}>{t("Calendar")}</ButtonTab>
			<ButtonTab to={`../overview`}>{t("Overview")}</ButtonTab>
		</ButtonTabs>
	);
};
